import { rackToString } from "src/services/item/rack.interface";
import { itemCategoryToString, ItemStatusDisplay } from "src/services/item/item-display";
import { dateRangeToString } from "src/services/utils/date.utils";
import { OrderStatusDisplay } from "src/services/order/order-display";

import { BackendBody } from "../../shared/backend-api.types";
import { assertNever } from "src/services/utils/enum.utils";

export type ItemHistory = BackendBody["ApiItemHistory"];
export type OrderHistory = BackendBody["ApiOrderHistory"];

function itemHistoryToString(itemHistory: ItemHistory): string {
  let displayString: string;

  switch (itemHistory.action) {
    case "createItem":
      displayString = `created item`;
      break;
    case "updateCategory":
      displayString = `updated category to ${itemCategoryToString(itemHistory.category)}`;
      break;
    case "updateLocation":
      displayString = `updated location to ${rackToString(itemHistory.location)}`;
      break;
    case "updateStatus":
      displayString = itemHistory.status
        ? `updated status to ${ItemStatusDisplay[itemHistory.status]}`
        : "updated status";
      break;
    default:
      assertNever(itemHistory.action);
  }

  return displayString;
}

function orderHistoryToString(orderHistory: OrderHistory): string {
  let displayString: string;

  switch (orderHistory.action) {
    case "acceptOrder":
      displayString = "accepted the driver assignment";
      break;
    case "assignDriver":
      displayString = "assigned driver";
      break;
    case "addedToCalendar":
      displayString = "added to its calendar";
      break;
    case "createOrder":
      displayString = "created order";
      break;
    case "deliveryStarted":
      displayString = "started delivery";
      break;
    case "deliveryCompleted":
      displayString = "completed delivery";
      break;
    case "dropAtWarehouse":
      displayString = "dropped items at warehouse";
      break;
    case "onboardingCompleted":
      displayString = "completed onboarding items";
      break;
    case "pickupStarted":
      displayString = "started pickup";
      break;
    case "pickupCompleted":
      displayString = "completed pickup";
      break;
    case "rejectOrder":
      displayString = "accepted the driver assignment";
      break;
    case "stagingCompleted":
      displayString = "completed staging";
      break;
    case "storingCompleted":
      displayString = "completed storing items";
      break;
    case "updateAddress":
      displayString = `updated address to ${orderHistory.address}`;
      break;
    case "updateFulfillmentDatetime": {
      const { earliestFulfillment, latestFulfillment } = orderHistory;

      displayString =
        earliestFulfillment && latestFulfillment
          ? `updated fulfillment to ${dateRangeToString(new Date(earliestFulfillment), new Date(latestFulfillment))}`
          : "updated fulfillment";
      break;
    }
    case "updateStatus":
      displayString = orderHistory.status
        ? `updated status to ${OrderStatusDisplay[orderHistory.status]}`
        : "updated status";
      break;
    case "uploadPicture":
      displayString = "attached a picture";
      break;
    default:
      assertNever(orderHistory.action);
  }

  return displayString;
}

export function isItemHistory(history: ItemHistory | OrderHistory): history is ItemHistory {
  return "itemHistoryId" in history;
}

export function isOrderHistory(history: ItemHistory | OrderHistory): history is OrderHistory {
  return "orderHistoryId" in history;
}

export function historyToString(history: ItemHistory | OrderHistory): string {
  if (isItemHistory(history)) {
    return itemHistoryToString(history);
  } else {
    return orderHistoryToString(history);
  }
}
